import { useEffect } from "react";
import { api } from "./api";
import { useI18n } from "./I18nContext";

export default function ConsentChecks({ consent, setConsent, onVersions, testPrefix = "consent" }) {
  const { t } = useI18n();

  useEffect(() => {
    api.get("/legal")
      .then((r) => {
        const next = { terms: "1.0", privacy: "1.0", beta: "1.0" };
        (r.data.items || []).forEach((it) => {
          if (next[it.slug] !== undefined) next[it.slug] = it.version;
        });
        if (onVersions) onVersions(next);
      })
      .catch(() => { /* keep defaults */ });
  }, [onVersions]);

  const legalLink = (slug, label) => (
    <a href={`/legal/${slug}`} target="_blank" rel="noopener noreferrer" className="tb-link" data-testid={`${testPrefix}-link-${slug}`}>
      {label}
    </a>
  );

  return (
    <div className="tb-consent-block tb-consent-block-slim" data-testid={`${testPrefix}-checks`} style={{ marginTop: 8 }}>
      <label className="tb-consent-row">
        <input
          type="checkbox"
          checked={consent.terms && consent.privacy}
          onChange={(e) => setConsent({ ...consent, terms: e.target.checked, privacy: e.target.checked })}
          required
          data-testid={`${testPrefix}-terms-privacy`}
        />
        <span>
          {t("auth.consentTermsPrefix")} {legalLink("terms", t("auth.consentTermsLink"))} {t("auth.consentAnd")} {legalLink("privacy", t("auth.consentPrivacyLink"))}.
        </span>
      </label>
      <label className="tb-consent-row">
        <input
          type="checkbox"
          checked={consent.beta}
          onChange={(e) => setConsent({ ...consent, beta: e.target.checked })}
          required
          data-testid={`${testPrefix}-beta`}
        />
        <span>
          {t("auth.consentBetaPrefix")} {legalLink("beta", t("auth.consentBetaLink"))}.
        </span>
      </label>
    </div>
  );
}
